import React, { useContext, useMemo } from "react";
import ProfilesAndSettings from "views/Config/Profiles/Common";
import { composedAPIAt } from "./api";
import interfaceComposition from "./composition";
import BqnContext from "common/BqnContext";
import { bqnIdTarget } from "common/api";
import help from "help/viewInterfaceProfileConfig.md";
import settingsHelp from "help/viewInterfaceProfileConfigSettings.md";

const ConfigInterfaceProfiles = ({ ...settings }) => {
  const { bqnId, clusterStatus } = useContext(BqnContext);
  const bqnIdAsked = bqnIdTarget(clusterStatus?.mode, bqnId);
  // The API is kept while the BQN selected is the same one: it is given as
  // the props of the view, which asks again for every set of them.
  const api = useMemo(() => composedAPIAt(bqnIdAsked), [bqnIdAsked]);

  return (
    <ProfilesAndSettings
      {...interfaceComposition}
      {...api}
      {...settings}
      help={help}
      settingsHelp={settingsHelp}
    />
  );
};

export default ConfigInterfaceProfiles;
